
import { Component, Vue } from "vue-property-decorator";
import Sidebar from "@/components/navigations/Sidebar.vue";
import CardProchaineActivite from "@/components/card/CardProchaineActivite.vue";
import CardCalendrier from "@/components/card/CardCalendrier.vue";
import CardActivite from "@/components/card/CardActivite.vue";
import Alert from "@/components/alert/Alert.vue";
import panelActivite from "@/components/panel/PanelActivite.vue";
import Modal from "@/components/modal/Modal.vue";
import Cta from "@/components/buttons/Button.vue";
import { login, toast } from "@/store";
import { found, select } from "@/helpers";
import { User, OnboardingSteps } from "@/models";
import LoginService from "@/services/login.service";

@Component({
  methods: {
    found,
    select,
  },
  components: {
    Sidebar,
    CardProchaineActivite,
    Cta,
    CardCalendrier,
    CardActivite,
    Alert,
    panelActivite,
    Modal,
  },
})
/** New-volunteer onboarding checklist page. */
export default class Onboarding extends Vue {
  private dataReady = false;

  async mounted(): Promise<void> {
    await login.onboarding();
  }

  /** Marks onboarding as complete once all steps are done, then redirects to the timeline. */
  private async validOnboarding() {
    if (await LoginService.onboardingValidation()) {
      await login.context();
      this.$router.replace("/accueil");
    } else {
      toast.pushError(
        "Ton onboarding n'a pas pu être cloturé. Pas de panique, réessayes ou bien contacte Jordan sur Slack."
      );
    }
  }

  private goFC() {
    this.$router.push({ name: "Recyclage" });
  }

  get context(): User | null {
    return login.getContext;
  }
  get onboarding(): OnboardingSteps | null {
    return login.getOnboarding;
  }

  get recyclageDemande(): boolean {
    return this.context?.roles.includes("ACCES_FC") ?? false;
  }
}
